import { openBlock as a, createElementBlock as e, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20"
};
function o(r, l) {
  return a(), e("svg", n, l[0] || (l[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.5 16.25V3.75a1.25 1.25 0 0 0-1.25-1.25H3.75A1.25 1.25 0 0 0 2.5 3.75v12.5a1.25 1.25 0 0 0 1.25 1.25h12.5a1.25 1.25 0 0 0 1.25-1.25M8.38 9.5h3.24L10 5.99zm-1.914 3.71a.625.625 0 0 1-.783-.848l3.875-8a.625.625 0 0 1 1.134 0l3.625 8a.625.625 0 0 1-1.134.524l-.987-2.137H7.804l-.987 2.137a.63.63 0 0 1-.351.324m-.689 1.628a.5.5 0 0 1-.554 0l-.196-.13a.5.5 0 1 0-.554.832l.195.13a1.5 1.5 0 0 0 1.664 0l.39-.26a.5.5 0 0 1 .555 0l.391.26a1.5 1.5 0 0 0 1.664 0l.39-.26a.5.5 0 0 1 .555 0l.391.26a1.5 1.5 0 0 0 1.664 0l.39-.26a.5.5 0 0 1 .555 0l.391.26a1.5 1.5 0 0 0 1.664 0l.195-.13a.5.5 0 1 0-.554-.832l-.196.13a.5.5 0 0 1-.554 0l-.39-.26a1.5 1.5 0 0 0-1.665 0l-.39.26a.5.5 0 0 1-.555 0l-.39-.26a1.5 1.5 0 0 0-1.665 0l-.39.26a.5.5 0 0 1-.555 0l-.39-.26a1.5 1.5 0 0 0-1.665 0z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: o };
export {
  d as default,
  o as render
};
